module.exports = new __parcel__URL__("oco2-mip-co2budget-yeargrid-v1.thumbnails.lateral.river.co2.flux.uncertainty.e3bc65a8.png").toString();